import React, {useState} from 'react';
import { Link } from 'react-router-dom';

const AlertModal = ({gameData, loadGame, clearGameData,  heading, description}) => {
    const [modal, setModal] = useState(!!gameData?.game);
    if (!gameData?.game) {
        return ;
    }
    const handleSetModal = () => {
        setModal(false);
        clearGameData();
    }
    const handleLoadingGame = (e) => {
        e.preventDefault();
        loadGame();
    }
    return ( modal &&
        <section className={`modal alert`}>
            <div className="overlay">
                <span className="loading-decor-l" />
                <span className="loading-decor-r" />
            </div>
            <div className="content relative">
                <div className="container md:!px-4 !px-8">
                    <div className={'alert-modal flex-col relative'}>
                        <div className={'alert-content'}>
                            <button className={'btn btn-header btn-utility absolute -top-5 right-0 close-alert'}
                                    onClick={handleSetModal}
                                    type="button"
                                    aria-label="Close"
                                >
                                <span><span className="modal-icon modal-icon-close" aria-hidden="true" /></span>
                            </button>
                            <span className="modal-trophy" role="img" aria-label="Trophy">
                                <span className="modal-icon modal-icon-trophy" aria-hidden="true" />
                            </span>
                            <h3 className={'my-4'}>{heading}</h3>
                            <p className={'text-xs'}>{description}</p>
                            <div className={'actions mt-6 flex md:flex-row flex-col justify-center items-center gap-4'}>
                                <span className={'play-button md:w-auto w-full'}>
                                    <button className={'btn btn-header w-full'} onClick={handleLoadingGame} type="button">
                                        <span className={`md:min-w-[160px] !bg-cover !py-3 min-w-[48px] min-h-[48px] md:min-w-auto md:min-h-auto`}>
                                            <span className="modal-icon modal-icon-game mr-2" aria-hidden="true" />
                                            <span className='!p-0 !bg-none'>Play Again</span>
                                        </span>
                                    </button>
                                </span>
                                <Link to={'/results'}
                                      className="btn btn-header md:w-auto w-full"
                                      aria-label={'See Winners'}>
                                    <span className={`md:min-w-[160px] !bg-cover !py-3 min-w-[48px] min-h-[48px] md:min-w-auto md:min-h-auto`}>
                                        <span className="modal-icon modal-icon-trophy mr-2" aria-hidden="true" />
                                        <span className='!p-0 !bg-none'>Winners</span>
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AlertModal;
